import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
}from 'react-router-dom'

import { lazy, Suspense } from 'react';

import './Assets/css/element.css';
import './components/pages/supplier/suppliers.css';


// const Footer = lazy(() => import( './components/footerComponents/footer'));
// const Homepage = lazy(() => import( './components/pages/homePage'));
// const News = lazy(() => import( './components/pages/news'));
// const FairsAndDates = lazy(() => import( './components/pages/fairsAndDates'));
// const Impressum = lazy(() => import( './components/pages/impressum'));
// const dsgvo = lazy(() => import( './components/pages/dsgvo'));
// const Kontakt = lazy(() => import( './components/pages/kontakt'));
// const Referenzen = lazy(() => import( './components/pages/referenzen'));
// const History = lazy(() => import( './components/pages/history'));
// const WhoWeAre = lazy(() => import( './components/pages/whoWeAre'));
// const SuppliersOverview = lazy(() => import( './components/pages/supplier/overview.js'));


// const WuF = lazy(() => import( './components/pages/supplier/wuf.js'));
// const SuB = lazy(() => import( './components/pages/supplier/sub.js'));
// const Aut = lazy(() => import( './components/pages/supplier/aut.js'));
// const Zub = lazy(() => import( './components/pages/supplier/zub.js'));

// //ZIERSCH
// const Ziersch = lazy(() => import( './components/pages/supplier/ziersch/mainPageSup.js'));
// const ZierschProducts = lazy(() => import( './components/pages/supplier/ziersch/subpages/schleifmaschinenOverview.js'));

// // Demmeler
// const Demmeler = lazy(() => import( './components/pages/supplier/demmeler/mainPageSup.js'));
// const DemmelerTische = lazy(() => import( './components/pages/supplier/demmeler/subpages/demmelerTable.js'));
// const DemmelerSonstiges = lazy(() => import( './components/pages/supplier/demmeler/subpages/demmelerSonstiges.js'));

// // Fehlmann
// const Fehlmann = lazy(() => import( './components/pages/supplier/fehlmann/mainPageSup.js'));
// const FehlmannVersa = lazy(() => import( './components/pages/supplier/fehlmann/subpages/versa.js'));
// const FehlmannPicomax = lazy(() => import( './components/pages/supplier/fehlmann/subpages/picomax.js'));


// // Fetzer
// const Fetzer = lazy(() => import( './components/pages/supplier/fetzer/mainPageSup.js'));
// const FetzerLager = lazy(() => import( './components/pages/supplier/fetzer/subpages/lager.js'));
// const FetzerSonstiges = lazy(() => import( './components/pages/supplier/fetzer/subpages/sonstiges.js'));


// // Almi
// const Almi = lazy(() => import( './components/pages/supplier/Almi/mainPageSup.js'));
// const AlmiPipeGrinders = lazy(() => import( './components/pages/supplier/Almi/subpages/pgs.js'));

// // Exeron
// const Exeron = lazy(() => import( './components/pages/supplier/exeron/mainPageSup.js'));
// const ExeronEdm = lazy(() => import( './components/pages/supplier/exeron/subpages/edm.js'));
// const ExeronHsc = lazy(() => import( './components/pages/supplier/exeron/subpages/hsc.js'));


// // Davi
// const Davi = lazy(() => import( './components/pages/supplier/davi/mainPageSup.js'));
// const DaviRund = lazy(() => import( './components/pages/supplier/davi/subpages/rundBiegen.js'));
// const DaviProfil = lazy(() => import( './components/pages/supplier/davi/subpages/profilBiegen.js'));

// const Pcam = lazy(() => import( './components/pages/supplier/pcam/mainPageSup.js'));

// // Loewer
// const Loewer = lazy(() => import( './components/pages/supplier/loewer/mainPageSup.js'));
// const loewerProducts = lazy(() => import( './components/pages/supplier/loewer/subpages/products.js'));

// const MSMarking = lazy(() => import( './components/pages/supplier/msmarking/mainPageSup.js'));

// const aeroLift = lazy(() => import( './components/pages/supplier/aerolift/mainPageSup.js'));
// const aeroLiftVakuumheber = lazy(() => import( './components/pages/supplier/aerolift/subpages/vakuumheber.js'));
// const aeroLiftBaustellengeraete = lazy(() => import( './components/pages/supplier/aerolift/subpages/baustellengeraete.js'));
// const aeroLiftSchlauchheber = lazy(() => import( './components/pages/supplier/aerolift/subpages/schlauchheber.js'));
// const aeroLiftAutomation = lazy(() => import( './components/pages/supplier/aerolift/subpages/automation.js'));

// const gressel = lazy(() => import( './components/pages/supplier/gressel/mainPageSup.js'));
// const slLaser = lazy(() => import( './components/pages/supplier/sllaser/mainPageSup.js'));
// const nordLock = lazy(() => import( './components/pages/supplier/nordlock/mainPageSup.js'));

// // Carif
// const carif = lazy(() => import( './components/pages/supplier/carif/mainPageSup.js'));
// const carifProducts = lazy(() => import( './components/pages/supplier/carif/subpages/products.js'));

// // Steidle
// const steidle = lazy(() => import( './components/pages/supplier/steidle/mainPageSup.js'));
// const steidleMMKS = lazy(() => import( './components/pages/supplier/steidle/subpages/mmks.js'));
// const steidlePic = lazy(() => import( './components/pages/supplier/steidle/subpages/pic.js'));

// // aalbers farina
// const Aalbersfarina = lazy(() => import( './components/pages/supplier/aalbers/mainPageSup.js'));
// const AalbersfarinaBlech = lazy(() => import( './components/pages/supplier/aalbers/subpages/blech.js'));
// const AalbersfarinaLang = lazy(() => import( './components/pages/supplier/aalbers/subpages/lang.js'));

// // Jara
// const Jara = lazy(() => import( './components/pages/supplier/jara/mainPageSup.js'));

// // ebs
// const Ebs = lazy(() => import( './components/pages/supplier/ebs/mainPageSup.js'));

// // bodor
// const Bodor = lazy(() => import( './components/pages/supplier/bodor/mainPageSup.js'));
// const BodorSchneiden = lazy(() => import( './components/pages/supplier/bodor/subpages/schneiden.js'));
// // const BodorSchweißen = lazy(() => import( './components/pages/supplier/bodor/subpages/schweißen.js'));
// const BodorAuto = lazy(() => import( './components/pages/supplier/bodor/subpages/auto.js'));

// // fanuc
// const Fanuc = lazy(() => import( './components/pages/supplier/fanuc/mainPageSup.js'));
// const FanucRobocut = lazy(() => import( './components/pages/supplier/fanuc/subpages/robocut.js'));


// const Highlight = lazy(() => import( './components/pages/highlight.js'));


// const Header = lazy(() => import( './components/headerComponents/header'));

import Footer from './components/footerComponents/footer';
import Homepage from './components/pages/homePage';
import News from './components/pages/news';
import FairsAndDates from './components/pages/fairsAndDates';
import Impressum from './components/pages/impressum';
import dsgvo from './components/pages/dsgvo';
import Kontakt from './components/pages/kontakt';
import Referenzen from './components/pages/referenzen';
import History from './components/pages/history';
import WhoWeAre from './components/pages/whoWeAre';
import SuppliersOverview from './components/pages/supplier/overview.js';


import WuF from './components/pages/supplier/wuf.js';
import SuB from './components/pages/supplier/sub.js';
import Aut from './components/pages/supplier/aut.js';
import Zub from './components/pages/supplier/zub.js';

//ZIERSCH
import Ziersch from './components/pages/supplier/ziersch/mainPageSup.js';
import ZierschProducts from './components/pages/supplier/ziersch/subpages/schleifmaschinenOverview.js';

// Demmeler
import Demmeler from './components/pages/supplier/demmeler/mainPageSup.js';
import DemmelerTische from './components/pages/supplier/demmeler/subpages/demmelerTable.js';
import DemmelerSonstiges from './components/pages/supplier/demmeler/subpages/demmelerSonstiges.js';

// Fehlmann
import Fehlmann from './components/pages/supplier/fehlmann/mainPageSup.js';
import FehlmannVersa from './components/pages/supplier/fehlmann/subpages/versa.js';
import FehlmannPicomax from './components/pages/supplier/fehlmann/subpages/picomax.js';


// Fetzer
import Fetzer from './components/pages/supplier/fetzer/mainPageSup.js';
import FetzerLager from './components/pages/supplier/fetzer/subpages/lager.js';
import FetzerSonstiges from './components/pages/supplier/fetzer/subpages/sonstiges.js';


// Almi
import Almi from './components/pages/supplier/Almi/mainPageSup.js';
import AlmiPipeGrinders from './components/pages/supplier/Almi/subpages/pgs.js';

// Exeron
import Exeron from './components/pages/supplier/exeron/mainPageSup.js';
import ExeronEdm from './components/pages/supplier/exeron/subpages/edm.js';
import ExeronHsc from './components/pages/supplier/exeron/subpages/hsc.js';


// Davi
import Davi from './components/pages/supplier/davi/mainPageSup.js';
import DaviRund from './components/pages/supplier/davi/subpages/rundBiegen.js';
import DaviProfil from './components/pages/supplier/davi/subpages/profilBiegen.js';

import Pcam from './components/pages/supplier/pcam/mainPageSup.js';

// Loewer
import Loewer from './components/pages/supplier/loewer/mainPageSup.js';
import loewerProducts from './components/pages/supplier/loewer/subpages/products.js';

import MSMarking from './components/pages/supplier/msmarking/mainPageSup.js';

import aeroLift from './components/pages/supplier/aerolift/mainPageSup.js';
import aeroLiftVakuumheber from './components/pages/supplier/aerolift/subpages/vakuumheber.js';
import aeroLiftBaustellengeraete from './components/pages/supplier/aerolift/subpages/baustellengeraete.js';
import aeroLiftSchlauchheber from './components/pages/supplier/aerolift/subpages/schlauchheber.js';
import aeroLiftAutomation from './components/pages/supplier/aerolift/subpages/automation.js';

import gressel from './components/pages/supplier/gressel/mainPageSup.js';
import slLaser from './components/pages/supplier/sllaser/mainPageSup.js';
import nordLock from './components/pages/supplier/nordlock/mainPageSup.js';

// Carif
import carif from './components/pages/supplier/carif/mainPageSup.js';
import carifProducts from './components/pages/supplier/carif/subpages/products.js';

// Steidle
import steidle from './components/pages/supplier/steidle/mainPageSup.js';
import steidleMMKS from './components/pages/supplier/steidle/subpages/mmks.js';
import steidlePic from './components/pages/supplier/steidle/subpages/pic.js';

// aalbers farina
import Aalbersfarina from './components/pages/supplier/aalbers/mainPageSup.js';
import AalbersfarinaBlech from './components/pages/supplier/aalbers/subpages/blech.js';
import AalbersfarinaLang from './components/pages/supplier/aalbers/subpages/lang.js';

// Jara
import Jara from './components/pages/supplier/jara/mainPageSup.js';

// ebs
import Ebs from './components/pages/supplier/ebs/mainPageSup.js';

// bodor
import Bodor from './components/pages/supplier/bodor/mainPageSup.js';
import BodorSchneiden from './components/pages/supplier/bodor/subpages/schneiden.js';
// import BodorSchweißen from './components/pages/supplier/bodor/subpages/schweißen.js';
import BodorAuto from './components/pages/supplier/bodor/subpages/auto.js';

// fanuc
import Fanuc from './components/pages/supplier/fanuc/mainPageSup.js';
import FanucRobocut from './components/pages/supplier/fanuc/subpages/robocut.js';


import Highlight from './components/pages/highlight.js';


import Header from './components/headerComponents/header';

class App extends Component {


  render() {


    
    window.scrollTo(0, 0);
    return (
      <Suspense fallback={<div>Loading...</div>}>
      {/* // <Router history={history}> */}
      <Router onUpdate={() => window.scrollTo(0, 0)} >
      <div className="App">
        <Header/>
          <Switch>
            {/* Routing */}
            <Route exact path='/' component={Homepage} />
            <Route exact path='/Impressum' component={Impressum} />
            <Route exact path='/News' component={News} />
            <Route exact path='/FairsAndDates' component={FairsAndDates} />
            <Route exact path='/Kontakt' component={Kontakt} />
            <Route exact path='/Referenzen' component={Referenzen} />
            <Route exact path='/History' component={History} />
            <Route exact path='/WhoWeAre' component={WhoWeAre} />
            <Route exact path='/DSGVO' component={dsgvo} />
            <Route exact path='/Highlight' component={Highlight} />

            {/* Suppliers */}
            <Route exact path='/Suppliers' component={SuppliersOverview} />
            <Route exact path='/Suppliers/WuF' component={WuF} />
            <Route exact path='/Suppliers/SuB' component={SuB} />
            <Route exact path='/Suppliers/Automatisierung' component={Aut} />
            <Route exact path='/Suppliers/Zubehoer' component={Zub} />
            {/* Ziersch */}
            <Route exact path='/Suppliers/Ziersch' component={Ziersch} />
            <Route exact path='/Suppliers/Ziersch/Maschinen' component={ZierschProducts} />
            {/* Demmeler */}
            <Route exact path='/Suppliers/Demmeler' component={Demmeler} />
            <Route exact path='/Suppliers/Demmeler/Schweißtische' component={DemmelerTische} />
            <Route exact path='/Suppliers/Demmeler/Innovationen' component={DemmelerSonstiges} />
            {/* Exeron */}
            <Route exact path='/Suppliers/Exeron' component={Exeron} />
            <Route exact path='/Suppliers/Exeron/EDM' component={ExeronEdm} />
            <Route exact path='/Suppliers/Exeron/HSC' component={ExeronHsc} />
            {/* Fehlmann */}
            <Route exact path='/Suppliers/Fehlmann' component={Fehlmann} />
            <Route exact path='/Suppliers/Fehlmann/Versa' component={FehlmannVersa} />
            <Route exact path='/Suppliers/Fehlmann/Picomax' component={FehlmannPicomax} />
            {/* Fetzer */}
            <Route exact path='/Suppliers/Fetzer' component={Fetzer} />
            <Route exact path='/Suppliers/Fetzer/Lager' component={FetzerLager} />
            <Route exact path='/Suppliers/Fetzer/Sonstiges' component={FetzerSonstiges} />
            {/* Almi */}
            <Route exact path='/Suppliers/Almi' component={Almi} />
            <Route exact path='/Suppliers/Almi/PipeGrinders' component={AlmiPipeGrinders} />
            {/* PCAM */}
            <Route exact path='/Suppliers/PCAM' component={Pcam} />
            {/* Davi */}
            <Route exact path='/Suppliers/Davi' component={Davi} />
            <Route exact path='/Suppliers/Davi/Rundbiegen' component={DaviRund} />
            <Route exact path='/Suppliers/Davi/Profilbiegen' component={DaviProfil} />
            {/* Loewer */}
            <Route exact path='/Suppliers/Loewer' component={Loewer} />
            <Route exact path='/Suppliers/Loewer/Produkte' component={loewerProducts} />
            {/* Msmarking */}
            <Route exact path='/Suppliers/MSMarking' component={MSMarking} />
            {/* Aerolift */}
            <Route exact path='/Suppliers/Aerolift' component={aeroLift} />
            <Route exact path='/Suppliers/Aerolift/Vakuumheber' component={aeroLiftVakuumheber} />
            <Route exact path='/Suppliers/Aerolift/Baustellengeraete' component={aeroLiftBaustellengeraete} />
            <Route exact path='/Suppliers/Aerolift/Schlauchheber' component={aeroLiftSchlauchheber} />
            <Route exact path='/Suppliers/Aerolift/Automation' component={aeroLiftAutomation} />
            {/* Gressel */}
            <Route exact path='/Suppliers/Gressel' component={gressel} />
            {/* SLLaser */}
            <Route exact path='/Suppliers/SLLaser' component={slLaser} />
            {/* Nordlock */}
            <Route exact path='/Suppliers/Nordlock' component={nordLock} />
            {/* esmatec
              <Route exact path='/Suppliers/Esmatec' component={esmatec} />*/}
            {/* Carif */}
            <Route exact path='/Suppliers/Carif' component={carif} />
            <Route exact path='/Suppliers/Carif/Produkte' component={carifProducts} />
            {/* Steidle */}
            <Route exact path='/Suppliers/Steidle' component={steidle} />
            <Route exact path='/Suppliers/Steidle/PIC' component={steidlePic} />
            <Route exact path='/Suppliers/Steidle/MMKS' component={steidleMMKS} />
            {/* aalbers farina */}
            <Route exact path='/Suppliers/aalbersfarina' component={Aalbersfarina} />
            <Route exact path='/Suppliers/aalbersfarina/Blechregale' component={AalbersfarinaBlech} />
            <Route exact path='/Suppliers/aalbersfarina/Langgutlager' component={AalbersfarinaLang} />
            {/* Jara */}
            <Route exact path='/Suppliers/Jara' component={Jara} />
            {/* EB.S. */}
            <Route exact path='/Suppliers/Ebs' component={Ebs} />
            {/* Bodor */}
            <Route exact path='/Suppliers/Bodor' component={Bodor} />
            <Route exact path='/Suppliers/Bodor/Laserschneiden' component={BodorSchneiden} />
            {/* <Route exact path='/Suppliers/Bodor/Laserschweißen' component={BodorSchweißen} /> */}
            <Route exact path='/Suppliers/Bodor/Automatisierung' component={BodorAuto} />
            {/* Fanuc */}
            <Route exact path='/Suppliers/Fanuc' component={Fanuc} />
            <Route exact path='/Suppliers/Fanuc/Robocut' component={FanucRobocut} />
            <Route component={Homepage} />
          </Switch>
        <Footer/>
      </div>
    </Router>
    </Suspense>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js